// export interface SelfieGridItem {
//   id: string; 
//   levelId: string;
//   level: number;
//   emoji: string;
//   requiresUpload: boolean;
// }

// export const selfieGridItems: SelfieGridItem[] =[
//   { id: "S0", levelId: "S0", level: 0, emoji: "📸", requiresUpload: true },
//   { id: "S1", levelId: "S1", level: 1, emoji: "✨", requiresUpload: false },
//   { id: "S2", levelId: "S2", level: 2, emoji: "🧙", requiresUpload: false },
//   { id: "S3", levelId: "S3", level: 3, emoji: "🎨", requiresUpload: false },
//   { id: "S4", levelId: "S4", level: 4, emoji: "👑", requiresUpload: false },
//   { id: "S5", levelId: "S5", level: 5, emoji: "🤖", requiresUpload: false },
// ];

// // L0 dahil toplam 6 adım var!
// export const SELFIE_LEVELS = selfieGridItems.length;


export interface SelfieGridItem {
  id: string; 
  levelId: string;
  level: number;
  emoji: string;
  requiresUpload: boolean;
}

// 🚀 DÜZELTME: S1 (Basit Filtreler) silindi. 
// Artık sırasıyla: Fantezi Karakteri (S2), Yağlı Boya (S3) ve Taht Odası (S4) var.
// Ekranda güzel görünmesi için "level" değerlerini 1, 2, 3 olarak sıraladık (L1, L2, L3 olarak görünecek).
export const selfieGridItems: SelfieGridItem[] =[
  { id: "S1", levelId: "S1", level: 2, emoji: "🧙", requiresUpload: false },
  { id: "S2", levelId: "S2", level: 3, emoji: "🎨", requiresUpload: false },
  { id: "S3", levelId: "S3", level: 4, emoji: "👑", requiresUpload: false },
];

export const SELFIE_LEVELS = selfieGridItems.length; // Toplam 3 seviye
